export enum AdminPitchListsRoutes {
  CreateLink = 'create-link',
  DeleteLinks = 'delete-links',
  GetLinks = 'get-links',
  RefreshLists = 'refresh-lists',
  RestoreLists = 'restore-lists',
  RestorePitch = 'restore-pitch',
  UpdateMany = 'update-many',
}
